module.exports = __webpack_public_path__ + "fonts/Garamond1689.otf";